/* components/Brand.tsx */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
function LogoMark(props: React.SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-25">
      <path d="M4 20 24 6 44 20" data-id="element-26" />
      <path d="M4 20v18a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V20" data-id="element-27" />
      <path d="M14 24 24 32 34 24" data-id="element-28" />
    </svg>;
}
interface BrandProps {
  isScrolled?: boolean;
}
export function Brand({
  isScrolled = false
}: BrandProps) {
  return <a href="/" aria-label="RealtyZen home" className="flex items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-29">
      {/* icon – always visible with scaling animation */}
      <motion.div animate={{
      scale: isScrolled ? 0.875 : 1
    }} // 28px from 32px
    transition={{
      duration: 0.3,
      ease: "easeOut"
    }} data-id="element-30">
        <LogoMark className="h-8 w-8 shrink-0 text-primary" data-id="element-31" />
      </motion.div>

      {/* word-mark – visible ≥ 640 px ("sm") with fade animation */}
      <AnimatePresence data-id="element-32">
        {!isScrolled && <motion.span className="hidden sm:inline font-display text-xl text-primary dark:text-linen-50" initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -10
      }} transition={{
        duration: 0.2
      }} data-id="element-33">
            RealtyZen
          </motion.span>}
      </AnimatePresence>
    </a>;
}